export enum FocusOn {
  REGION = 'regions',
  CITY = 'cities',
}
